import React from 'react';

import appContent from '@/services/content/appContent.typed';
import type {AutoDeliveryPrice} from '@/types/icc/autoDeliveryDetails';
import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxOrderSummaryProps {
    className?: string;
    price: AutoDeliveryPrice;
}

const AutoDeliveryDcxOrderSummary = ({className, price}: AutoDeliveryDcxOrderSummaryProps) => {
    const {currencySign, delivery, total, subTotal} = price;
    const content = appContent.getAutoDeliveryContent()?.extendedDetailsContent;
    const {yourOrderSubtotalLabel, yourOrderDeliveryLabel, yourOrderTotalLabel, yourOrderDeliveryFreeLabel} =
        content || {};

    const formatPrice = (amount: number | null): string | null => {
        if (amount == null) return null;
        if (amount === 0) return yourOrderDeliveryFreeLabel || null;

        return currencySign ? `${currencySign} ${amount}` : `${amount}`;
    };

    return (
        <div className={className}>
            <div className='flex flex-col gap-2'>
                <SummaryItem title={yourOrderSubtotalLabel} value={formatPrice(subTotal)} />
                <SummaryItem title={yourOrderDeliveryLabel} value={formatPrice(delivery)} />
                <SummaryItem title={yourOrderTotalLabel} value={formatPrice(total)} className='font-bold' />
            </div>
        </div>
    );
};

export default AutoDeliveryDcxOrderSummary;

interface SummaryItemProps {
    title?: string;
    value: string | null;
    className?: string;
}

const SummaryItem = ({title, value, className}: SummaryItemProps) => {
    if (!title || !value) return null;

    return (
        <div className={twx('flex justify-between', className)}>
            <span>{title}</span>
            <span>{value}</span>
        </div>
    );
};
